import { hash } from '@ember/helper';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import type { WithBoundArgs } from '@glint/template';
import HotelBenchmarkInsightGridExpandableGridExpandableItemButton from 'lumen/components/hotel/benchmark-insight/grid-expandable/grid-expandable-item-button';

interface HotelBenchmarkInsightGridExpandableGridExpandableItemSignature {
  Args: {
    expandedIndices: number[];
    index: number;
    reflowChart?: () => void;
    toggleExpandedIndex: (index: number) => void;
  };
  Blocks: {
    default: [
      {
        ExpandButton: WithBoundArgs<
          typeof HotelBenchmarkInsightGridExpandableGridExpandableItemButton,
          'isExpanded' | 'onClick'
        >;
        isExpanded: boolean;
      },
    ];
  };
}

export default class HotelBenchmarkInsightGridExpandableGridExpandableItem extends Component<HotelBenchmarkInsightGridExpandableGridExpandableItemSignature> {
  get isExpanded(): boolean {
    const { expandedIndices, index } = this.args;

    return expandedIndices.includes(index);
  }

  @action handleClick(): void {
    const { index, reflowChart, toggleExpandedIndex } = this.args;

    toggleExpandedIndex(index);

    // Highcharts needs to measure the new container dimensions after the DOM has been updated.
    // Use requestAnimationFrame to ensure DOM is updated.
    requestAnimationFrame(() => {
      reflowChart?.();
    });
  }

  <template>
    <div class={{if this.isExpanded "order-first col-span-full"}}>
      {{yield
        (hash
          ExpandButton=(component
            HotelBenchmarkInsightGridExpandableGridExpandableItemButton
            isExpanded=this.isExpanded
            onClick=this.handleClick
          )
          isExpanded=this.isExpanded
        )
      }}
    </div>
  </template>
}
